/**
 * @copyright [W3Schools]{@link https://www.w3schools.com/howto/howto_js_copy_clipboard.asp}
 * @param {string} text text to be copied to clipboard
 */
function copyToClipboard(text) {
  const copyText = document.createElement('textarea');
  copyText.value = text;
  document.body.appendChild(copyText);

  /* Select the text field */
  copyText.select();
  copyText.setSelectionRange(0, 99999); /* For mobile devices */

  /* Copy the text inside the text field */
  document.execCommand('copy');
  document.body.removeChild(copyText);
}
export { copyToClipboard };